import { useState } from 'react'

import {
	EuiButton,
	EuiContextMenuItem,
	EuiContextMenuPanel,
	EuiPopover,
} from '@equipmentshare/ds2'

import { useFlags } from '@equipmentshare/feature-flags'
import PermissionsCheck from 'components/PermissionsCheck'
import { Permission } from '../../../../graphql'

export type EditMenuProps = {
	onEdit: () => void,
	onAdjustQuantity: () => void,
	onConvertItemsToMany: () => void,
	onConvertItems: () => void,
	onOverrideWac: () => void,
  onDeleteItem: () => void,
	className?: string,
}

export default function EditMenu( { onEdit, onAdjustQuantity, onConvertItemsToMany, onConvertItems, onOverrideWac, onDeleteItem, className }: EditMenuProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const flags = useFlags()

	const button = (
		<EuiButton
			iconType="arrowDown"
			iconSide="right"
			fill
			onClick={() => setIsPopoverOpen( !isPopoverOpen )}
		>
			Edit
		</EuiButton>
	)

	const conversionFunction = flags.enableTswConvertItemOneToMany ? onConvertItemsToMany : onConvertItems
	const onClickConvertParts = () => {
		setIsPopoverOpen( false )
		conversionFunction()
	}

	const items = [
		<EuiContextMenuItem
			key="editDetails"
			onClick={onEdit}
		>
			Edit details
		</EuiContextMenuItem>,

		<PermissionsCheck
			key="editQuantity"
			permissionsToCheck={[ Permission.CanCreateDecrementAdjustmentByStoreId, Permission.CanCreateIncrementAdjustmentByStoreId ]}
			operator="any"
		>
			<EuiContextMenuItem
				onClick={onAdjustQuantity}
			>
				Edit quantity
			</EuiContextMenuItem>
		</PermissionsCheck>,

		...flags.enableTswWeightedAverageCost
			? [
				<PermissionsCheck
					key="editWac"
					permissionsToCheck={[ Permission.CanOverrideWeightedAverageCostByStoreId ]}
				>
					<EuiContextMenuItem
						onClick={onOverrideWac}
					>
						Edit WAC
					</EuiContextMenuItem>
				</PermissionsCheck>
			 ] : [],

		<PermissionsCheck
			key="convertItem"
			permissionsToCheck={[ Permission.CanConvertPartsByStoreId ]}
		>
			<EuiContextMenuItem onClick={onClickConvertParts}>
        Convert items
			</EuiContextMenuItem>
		</PermissionsCheck>,

		<EuiContextMenuItem
			key="removeFromInventory"
			onClick={onDeleteItem}>
      Delete item
		</EuiContextMenuItem>
	]

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={() => setIsPopoverOpen( false )}
			className={className}
		>
			<EuiContextMenuPanel items={items} />
		</EuiPopover>
	)
}
